
import React, {Component} from 'react';
import {Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import SWTNewCustomerModal from './SWTNewCustomerModal'


class SWTNewCustomerButton extends Component {

  constructor(...args){
    super(...args)
    this.state = {show:false}
  }

  onClick(){
    this.refs.newCustomerPop.openPopup()
    //this.refs.swtCustPage.loadPage()
    this.setState({show:true})
  }

  render(){
    let {show} = this.state
    return (
      <div>        
        <Button  onClick={this.onClick.bind(this)}><FontAwesome name='plus'/></Button>        
        <SWTNewCustomerModal ref={'newCustomerPop'} show={show} onHide={()=>{this.setState({show:false})}}/>
      </div>
    )
  }
}


export default SWTNewCustomerButton;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTNewCustomerButton.js